"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserSettings = void 0;

var getUserSettings = function getUserSettings(state) {
  return state.userSettings;
};

exports.getUserSettings = getUserSettings;